import { useEffect, useState } from 'react';
import '../css/ListarPontoMototaxi.css';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

// API simulada (substituir pela real quando disponível)
import { buscarPontosDeMototaxiByRepresentante } from '../servicos/listagemServico';
import { excluirPontoMototaxi } from '../servicos/exclusaoServico';

function ListarPontoMototaxi() {

  const [pontos, setPontos] = useState([]);
  const navigate = useNavigate();

  const BASE_URL =
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
      ? 'http://127.0.0.1:8000' 
      : 'https://mercadinhointeligente.com.br';


  useEffect(() => {

    console.log('-----------------');
    console.log('Entrou no useEffect do ListarPontoMototaxi.js....');

    const carregarPontos = async () => {
      try {
        const cookies = Cookies.get();
        const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

        console.log('dadosCookies: ');
        console.log(dadosCookies);

        console.log('id do representante: ');
        console.log(dadosCookies.dadosRepresentanteComercial.id);

        if (!dadosCookies || !dadosCookies.dadosRepresentanteComercial?.id) {
          alert("Erro: dados do representante comercial não encontrados.");
          return;
        }

        // const idRepresentante = dadosCookies.dadosRepresentanteComercial.id;

        console.log('preparando pra buscar os pontos do representante...');

        const resposta = await buscarPontosDeMototaxiByRepresentante(dadosCookies);

        console.log('Resposta: ');
        console.log(resposta);

        console.log('Pontos: ');
        console.log(resposta.pontosMototaxi);


        setPontos(resposta.pontosMototaxi); // Espera um array de objetos

      } catch (erro) {
        console.error("Erro ao buscar pontos:", erro);
        alert("Erro ao buscar pontos cadastrados.");
      }
    };

    carregarPontos();
  }, []);


const handleExcluir = async (id) => {
  const confirmado = window.confirm('Tem certeza que deseja excluir este ponto?');
  if (!confirmado) return;

  try {
    const response = await excluirPontoMototaxi(id);

    // Caso a função excluirPontoMototaxi já retorne um objeto com status (fetch)
    // ou seja a resposta do axios (response.data), tentamos pegar o status.
    const status = response?.status ?? response?.statusCode ?? null;

    // Se a API já retornou sucesso aqui, atualiza a lista normalmente
    setPontos((prev) => prev.filter((ponto) => ponto.id !== id));
    alert('Ponto excluído com sucesso.');
  } catch (error) {
    console.error('Erro ao excluir ponto:', error);

    // Vários formatos possíveis dependendo de como excluirPontoMototaxi foi implementado
    const axiosResp = error?.response; // axios
    const fetchResp = error; // fetch might not throw with response, but handle below

    // 1) Se for axios e tiver response (mais comum)
    if (axiosResp) {
      const status = axiosResp.status;
      const data = axiosResp.data || {};

      // Se for 409 mostramos a mensagem específica do backend
      if (status === 409) {
        const msg = data.message || data.errors || 'Não foi possível excluir: existem pilotos vinculados.';
        alert(msg);
        return;
      }

      // outros status
      const msg = data.message || data.errors || `Erro ao excluir (status ${status}).`;
      alert(msg);
      return;
    }

    // 2) Se for fetch e a função lançar um objeto com status/data
    if (error && typeof error === 'object' && ('status' in error || 'data' in error)) {
      const status = error.status;
      const data = error.data || {};
      if (status === 409) {
        const msg = data.message || data.errors || 'Não foi possível excluir: existem pilotos vinculados.';
        alert(msg);
        return;
      }
      const msg = data.message || data.errors || `Erro ao excluir (status ${status}).`;
      alert(msg);
      return;
    }

    // 3) fallback genérico (mensagem da exceção ou message)
    const fallbackMsg =
      (error && (error.message || error.toString())) ||
      'Erro desconhecido ao excluir ponto.';
    alert('Erro ao excluir ponto: ' + fallbackMsg);
  }
};


  return (
    <div className="listar-ponto-mototaxi">
      <div className="card p-4 shadow-sm" style={{ width: '100%', maxWidth: '800px', margin: '2rem auto' }}>
        <div className="card-body">
          <h3 className="text-center mb-4">Pontos de Mototáxi Cadastrados</h3>

          {pontos.length === 0 ? (
            <p className="text-center">Nenhum ponto encontrado.</p>
          ) : (
            <div className="lista-pontos">
              {pontos.map((ponto) => {
                // monta a URL da logomarca para o ponto atual (usa ponto.id)
                const imagemLogomarca = `${BASE_URL}/storage/imagens/pontoMotoTaxi/logomarca_ponto_mototaxi_${ponto.id}.png`;

                return (
                  <div key={ponto.id} className="ponto-item mb-4 p-3 border rounded">
                    <h5>{ponto.name}</h5>

                    <div className="mb-3">
                      {/* <label className="form-label">Logomarca atual:</label> */}
                      <div>
                        <a href={imagemLogomarca} target="_blank" rel="noopener noreferrer">
                          <img
                            src={imagemLogomarca}
                            alt={`Logomarca do ponto ${ponto.id}`}
                            className="img-fluid rounded"
                            style={{ maxWidth: '200px', height: 'auto' }}
                            onError={(e) => {
                              // esconde imagem quebrada e registra no console para debug
                              e.currentTarget.style.display = 'none';
                              console.warn('Logomarca não encontrada em:', imagemLogomarca);
                            }}
                          />
                        </a>
                      </div>
                    </div>

                    <p
                      className={
                        ponto.qtdDiasVencimento < 0
                          ? 'bg-danger text-white p-1 rounded'   // vermelho
                          : ponto.qtdDiasVencimento === 0
                          ? 'bg-secondary text-white p-1 rounded'// substituto para laranja
                          : ponto.qtdDiasVencimento <= 7
                          ? 'bg-warning text-dark p-1 rounded'   // amarelo
                          : 'bg-success text-white p-1 rounded'  // azul
                      }
                    >
                      <strong>Qtd dias vencimento:</strong> {ponto.qtdDiasVencimento}
                    </p>

                    <p><strong>Nome do ponto:</strong> {ponto.user?.name}</p>
                    <p><strong>Responsável:</strong> {ponto.nome_responsavel_pelo_ponto}</p>
                    <p><strong>E-mail:</strong> {ponto.user?.email}</p>
                    <p><strong>Endereço:</strong> {ponto.endereco}, {ponto.bairro}, {ponto.cidade} - {ponto.uf}</p>
                    <p><strong>Telefone:</strong> {ponto.numero_celular_com_ddd}</p>
                    <p><strong>Status:</strong> {ponto.st_is_ativo ? 'Ativo' : 'Inativo'}</p>
                    <p><strong>Vigência:</strong> {ponto.data_inicio_vigencia} até {ponto.data_fim_vigencia || 'indeterminado'}</p>

                    <p><strong>Serviços Atendidos:</strong></p>
                    <p>
                      {ponto.servicos_atendidos
                        ?.map((servico) => servico.nome_tipo_servico)
                        .join(', ')}
                    </p>


                    <p>
                      <strong>Qtd Pilotos: </strong>{ponto.qtdPilotos}
                    </p>

                    <button
                      className="btn btn-danger me-2"
                      onClick={() => handleExcluir(ponto.id)}
                    >
                      Excluir Ponto
                    </button>

                    <button
                      className="btn btn-warning me-2"
                      onClick={() => navigate('/cadastrar-ponto-mototaxi', { state: { ponto } })}
                    >
                      Editar Ponto
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );

}

export default ListarPontoMototaxi;
